export function formatDate(isoString: string): string {
  if (!isoString) return "";

  const date = new Date(isoString);

  // Example output: 30 Jan 2026
  return date.toLocaleDateString("en-IN", {
    day: "2-digit",
    month: "short",
    year: "numeric",
  });
}

export const prettify = (s: string) =>
  s?.replace(/([A-Z])/g, " $1")?.replace(/^./, (c) => c?.toUpperCase());

export const upperCasePerttify=(s: string) =>
  s
    ?.replace(/([A-Z])/g, " $1")
    ?.replace(/^./, (c) => c?.toUpperCase())
    ?.toUpperCase();